import { render, staticRenderFns } from "./SeletorIdioma.vue?vue&type=template&id=12252b52"
import script from "./SeletorIdioma.vue?vue&type=script&lang=js"
export * from "./SeletorIdioma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports